export default __webpack_public_path__ + "static/media/arrow-down.c913e62c.svg";